import { routerMiddleware } from 'connected-react-router/immutable';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'hist... Remove this comment to see the full error message
import { createHashHistory } from 'history';
// eslint-disable-next-line import/no-deprecated -- Deprecated: **We recommend using the `configureStore` method
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import createRootReducer, { resetEnhancer } from './rootReducer';

const history = createHashHistory();
const rootReducer = createRootReducer(history);

const router = routerMiddleware(history);
const enhancer = applyMiddleware(thunk, router);

function configureStore(initialState: any) {
  // eslint-disable-next-line import/no-deprecated -- Deprecated: **We recommend using the `configureStore` method
  return createStore(resetEnhancer(rootReducer), initialState, enhancer);
}

export default { configureStore, history };
